@if (paginationInfo()?.totalNumberOfResults > 0) {
  <div class="sh-pagination">
    <div class="sh-pagination__page-size-selector">
      <select [id]="resultsPerPageSelectId" class="sh-select" [formControl]="resultsPerPageControl">
        @for (option of resultsPerPageOptions; track option) {
          <option [value]="option">{{ option }}</option>
        }
      </select>
      <label [attr.for]="resultsPerPageSelectId" class="sh-pagination__page-size-selector__label">{{ perPageMsg }}</label>
    </div>
    <div class="sh-pagination__actions">
      <sh-action-item [item]="$previousPageActionItem()"></sh-action-item>

      <span class="sh-pagination__actions__current">
        <input
          #goToInput
          [id]="goToPageInputId"
          type="number"
          min="1"
          [max]="$totalPages()"
          [attr.aria-label]="'components.pagination.go-to' | translate"
          class="sh-input-field -sh-small sh-pagination__actions__current-input"
          [formControl]="goToPageControl"
          (focus)="goToInput.select()"
          (keydown.enter)="goToPage()"
          (keydown.arrowUp)="stepPage(1, $event)"
          (keydown.arrowDown)="stepPage(-1, $event)"
          (change)="queueGoToPage()"
          (blur)="goToPage()"
        />
        <span class="sh-pagination__actions__total">/ {{ $totalPages() }}</span>
      </span>

      <sh-action-item [item]="$nextPageActionItem()"></sh-action-item>
    </div>
  </div>
}
